import moment from 'moment';

import { IPosition, IPositionsQueue, IStage } from '@entities/gantt/model/types';

export const movedAllPositionData = (newDate: string, stages: IStage[]): IPositionsQueue[] => {
    const allPositions: IPosition[] = [];

    stages.forEach((stage) => {
        stage.positions.forEach((position) => {
            const { isParent } = position;
            if (isParent) {
                position.children.forEach((children) => {
                    allPositions.push(children);
                });
            } else {
                allPositions.push(position);
            }
        });
    });

    const sortedStages = [...stages].sort(
        (stageA, stageB) =>
            moment(stageA.planned.startDate).valueOf() - moment(stageB.planned.startDate).valueOf()
    );

    const sortedPositions = allPositions
        .filter((position) => position.planned.startDate && position.type === 'labor')
        .sort(
            (positionA, positionB) =>
                moment(positionA.planned.startDate).valueOf() -
                moment(positionB.planned.startDate).valueOf()
        );

    const firstStageInitStartDate = sortedPositions[0].planned.startDate;

    const isNeedMove = newDate !== firstStageInitStartDate;
    const moveDays = moment(newDate).diff(moment(firstStageInitStartDate), 'days');

    const positionsQueue: IPositionsQueue[] = [];

    sortedStages.forEach((stage) => {
        if (isNeedMove) {
            const stagePositions: IPosition[] = [];
            stage.positions.forEach((position) => {
                const { isParent } = position;
                if (isParent) {
                    position.children.forEach((children) => {
                        stagePositions.push(children);
                    });
                } else {
                    stagePositions.push(position);
                }
            });

            stagePositions
                .filter((position) => position.planned.startDate)
                .forEach((position) => {
                    const planned = {
                        ...position.planned,
                        startDate: moment(position.planned.startDate)
                            .add(moveDays, 'days')
                            .format(),
                        endDate: moment(position.planned.endDate).add(moveDays, 'days').format(),
                    };
                    positionsQueue.push({
                        data: {
                            data: {
                                guid: position.guid,
                                startDate: moment(planned.startDate).format('YYYY-MM-DD'),
                                endDate: moment(planned.endDate).format('YYYY-MM-DD'),
                            },
                            type: 'update',
                            action: 'picker_update_stage',
                        },
                        subEntityType: 'step',
                        subEntityId: stage.id,
                        t: Date.now(),
                    });
                });
        }
    });

    return positionsQueue;
};
